"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerProductsInnerVariantsInnerTrimRgbToJSON = exports.StoresInnerProductsInnerVariantsInnerTrimRgbFromJSONTyped = exports.StoresInnerProductsInnerVariantsInnerTrimRgbFromJSON = exports.instanceOfStoresInnerProductsInnerVariantsInnerTrimRgb = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoresInnerProductsInnerVariantsInnerTrimRgb interface.
 */
function instanceOfStoresInnerProductsInnerVariantsInnerTrimRgb(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInnerProductsInnerVariantsInnerTrimRgb = instanceOfStoresInnerProductsInnerVariantsInnerTrimRgb;
function StoresInnerProductsInnerVariantsInnerTrimRgbFromJSON(json) {
    return StoresInnerProductsInnerVariantsInnerTrimRgbFromJSONTyped(json, false);
}
exports.StoresInnerProductsInnerVariantsInnerTrimRgbFromJSON = StoresInnerProductsInnerVariantsInnerTrimRgbFromJSON;
function StoresInnerProductsInnerVariantsInnerTrimRgbFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'r': !(0, runtime_1.exists)(json, 'r') ? undefined : json['r'],
        'g': !(0, runtime_1.exists)(json, 'g') ? undefined : json['g'],
        'b': !(0, runtime_1.exists)(json, 'b') ? undefined : json['b'],
    };
}
exports.StoresInnerProductsInnerVariantsInnerTrimRgbFromJSONTyped = StoresInnerProductsInnerVariantsInnerTrimRgbFromJSONTyped;
function StoresInnerProductsInnerVariantsInnerTrimRgbToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'r': value.r,
        'g': value.g,
        'b': value.b,
    };
}
exports.StoresInnerProductsInnerVariantsInnerTrimRgbToJSON = StoresInnerProductsInnerVariantsInnerTrimRgbToJSON;
